import { Input } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { convertNumberTimeToStringTime, convertStringTimeToNumberTime } from "../../../util/varibles/global";
import styles from './style.module.scss';
interface IProps {
    value?: number
    isNotZero?: boolean
    className?: string
    placeholder?: string
    disabled?: boolean
    borderless?: boolean

    onError?(empty?: boolean): void

    onChange(value: number | undefined): void

    onBlur?(): void
}

const InputDuration: React.FC<IProps> = ({
    value,
    disabled,
    isNotZero,
    className,
    placeholder = 'In duration (4d 6h 45m)',
    borderless,
    onError,
    onChange,
    onBlur
}) => {
    const [text, setText] = useState(convertNumberTimeToStringTime(value));
    const currentValue = useRef(value);

    useEffect(() => {
        if (!value)
            setText('')
        else if (currentValue.current !== value) {
            setText(convertNumberTimeToStringTime(value))
        }
    }, [value])

    const handleBlur = (e: any) => {
        const durationTxt = e.target.value.replace(/ {2,}/g, ' ').toLowerCase();
        const duration = convertStringTimeToNumberTime(durationTxt.trim());

        if (onError) {
            if (duration === undefined)
                onError(!(durationTxt.length > 0));
            else if (isNotZero && duration === 0) {
                onError(true);
            }
        }

        if (onBlur)
            onBlur();
    };

    const handleChange = (e: any) => {
        const durationTxt = e.target.value.replace(/ {2,}/g, ' ').toLowerCase();
        setText(e.target.value);
        const duration = convertStringTimeToNumberTime(durationTxt.trim());
        onChange(duration);
    };

    return <Input
        disabled={disabled}
        variant={borderless ? 'borderless' : undefined}
        className={[styles.wrapper, className].join(', ')}
        placeholder={placeholder}
        value={text || ''}
        onChange={handleChange}
        onBlur={handleBlur}
    />;
};

export default InputDuration;
